import { useReactiveVar } from '@apollo/client';
import { Button } from '@ri-digital/web-component-library/src/atom/Button';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import style from './EuDutyModalSkeleton.scss';
import { CLOSE_EU_DUTY_MODAL } from '../../constants/eventNames';
import {
  euDutyContinueAction,
  euDutyCountry,
  euDutyCountryCode,
  euDutyCurrency,
  euDutyCurrencySymbol,
  euDutyThresholdAmount,
  isEuDutyCurrencyIssue,
} from '../../lib/reactives';

const cx = classNames.bind(style);

const EuDutyModalSkeleton = ({ children, eventName }) => {
  const [open, setOpen] = useState(false);
  const isEuDutyCurrencyIssueCase = useReactiveVar(isEuDutyCurrencyIssue);
  const euDutyCountryCase = useReactiveVar(euDutyCountry);
  const euDutyCurrencyCase = useReactiveVar(euDutyCurrency);
  const euDutyCurrencySymbolCase = useReactiveVar(euDutyCurrencySymbol);
  const euDutyThresholdAmountCase = useReactiveVar(euDutyThresholdAmount);
  const euDutyCountryCodeCase = useReactiveVar(euDutyCountryCode);

  const closeModal = () => {
    setOpen(false);
    euDutyContinueAction(null);
  };

  const openModal = () => {
    setOpen(true);
  };

  const content = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child;
    }

    if (typeof child.type === 'string') {
      return child;
    }

    return React.cloneElement(child, {
      isEuDutyCurrencyIssueCase,
      euDutyCountryCase,
      euDutyCurrencyCase,
      euDutyCurrencySymbolCase,
      euDutyThresholdAmountCase,
      euDutyCountryCodeCase,
    });
  });

  useEffect(() => {
    window.addEventListener(eventName, openModal);
    window.addEventListener(CLOSE_EU_DUTY_MODAL, closeModal);
    return () => {
      window.removeEventListener(eventName, openModal);
      window.removeEventListener(CLOSE_EU_DUTY_MODAL, closeModal);
    };
  }, [eventName]);

  if (!open) {
    return null;
  }

  return (
    <div className={cx('modal')} data-qa="modal">
      <button
        type="button"
        className={cx('modal__backdrop')}
        onClick={closeModal}
        aria-label="Close modal"
      />
      <div className={cx('modal__content')} data-qa="modal-content">
        {content}
        <div className={cx('cancel-btn-wrapper')}>
          <Button
            title="close"
            className={cx('modal__close')}
            onClick={closeModal}
            qaTag="modal-close"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

EuDutyModalSkeleton.propTypes = {
  children: PropTypes.node.isRequired,
  eventName: PropTypes.string.isRequired,
};

export default EuDutyModalSkeleton;
